<script setup lang="ts">
const rules = [
  "KEEP Nickname clean",
  "NO profanity",
  "NO talk of violence and harm",
  "NO sexually explicit content",
  "NO promoting other sites",
  "NO Politics",
  "DO enjoy conversing with other poker fans",
];
</script>

<template>
  <PgDialogContainer title="Chat Rules">
    <div class="bg-black p-3 text-white">
      <p
        v-for="(rule, index) in rules"
        :key="`rule-${index}`"
        class="mt-4 text-2xl"
      >
        {{ rule }}
      </p>
    </div>
  </PgDialogContainer>
</template>

<style scoped></style>
